import React from 'react';
import './bio.css'
import Imagen1 from '../../images/bio/7F5A6823.jpg'
import Imagen2 from '../../images/bio/STLDUO1_ZIPPO.jpg'
import { Fade } from "react-awesome-reveal";

function Bio() {
    return (
        <section className='biowrapper' id='bio'>
            <div className='parte1'>
                <div className='biofoto1'>
                    <Fade duration={1500} delay={100} fraction={0.2}>
                        <img src={Imagen1} className='img1es' alt="Eriola Postoli" />
                        
                    </Fade>
                </div>
                <div className='biotexto'>
                    <Fade duration={1500} delay={100} fraction={0.3}>
                        <h2>IRMGARD AMY MÜNCHGESANG</h2>
                    </Fade>
                    <Fade duration={1500} delay={100} fraction={0.3}>
                        <p>
                Violista y cantante especializada en <strong>tango</strong>. Se formó junto a la <strong>Orquesta Escuela Municipal de Tango
                (Rosario)</strong> dirigida por javier Martinez Lo Re e integró reconocidas agrupaciones como el <strong>Conjunto
                Sextango de Omar Torres</strong>, la <strong>Orquesta Carlos Quilici</strong> y la <strong>Orquesta de Señoritas</strong>. Con varias de ellas,
                participó en proyectos de circulación artística en Europa, desempeñándose tanto como música como
                productora. Además de su labor como intérprete, se ha desarrollado como arregladora, compositora y
                sesionista, colaborando en proyectos de diversos géneros musicales dentro de la escena rosarina. Es
                militante feminista e integrante del <strong>Colectivo de Mujeres Tangueras Rosario</strong>, impulsando espacios más
                equitativos dentro del tango. Actualmente, forma parte de la <strong>Orquesta Sinfónica Provincial de Rosario</strong>
                y se desempeña como docente en distintos ámbitos. Se encuentra trabajando en su primer material discográfico solista.
                </p>
                <br></br>
                <p className='photographer'>Fotografía por Eriola Postoli</p>
                    </Fade>
                </div>
            </div>
            <div className="parte2">
                
                <div className='biotexto'>
                <Fade bottom duration={1500} delay={100} fraction={0.3}>
                <p>
            Nacida en <strong>Alemania</strong> y radicada en <strong>Argentina</strong>. Inició sus estudios de viola en Alemania y luego
            completó su formación en Nijmegen (Países Bajos). Licenciada en <strong>Terapias Artísticas</strong> con especialidad
            música.

                    </p>
                    <br></br>
                <p className='photographer'>Fotografía por Zippo Zimmermann</p>
                </Fade>

                </div>
                <div className='biofoto2'>
                    <Fade duration={1500} delay={100} fraction={0.2}>
                        <img src={Imagen2} className='img2es' alt="Zippo Zimmermann" />
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Bio